module.exports = __webpack_public_path__ + "static/media/download-app-store.1cfd5dba.svg";